export const environment = {
  production: false,
  groupName: "Fitness-For-Service-Level1-Web-User-Access",
  envName: 'DEV'
};
